export const determineClientOrServer = () =>
  typeof global !== "undefined" && typeof window === "undefined"
    ? "server"
    : "client";
